import type { Point } from "../types";

/** Slow at both ends with one smooth acceleration/deceleration curve. */
export function smoothTokenMotion(progress: number) {
  const t = Math.max(0, Math.min(1, progress));
  return t * t * (3 - 2 * t);
}

export function tokenSlideDuration(from: Point, to: Point) {
  const distance = Math.hypot(to.x - from.x, to.y - from.y);
  return Math.max(360, Math.min(800, 360 + distance * 38));
}

export function interpolateTokenPosition(from: Point, to: Point, progress: number): Point {
  const eased = smoothTokenMotion(progress);
  return { x: from.x + (to.x - from.x) * eased, y: from.y + (to.y - from.y) * eased };
}
